import gql from 'graphql-tag'

export const PRODUCT_DERIVED_ENTITIES_EXPORT_QUERY = gql`
    query productDerivedEntitiesExport {
        productDerivedEntitiesExport {
            status
        }
    }
`
